import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import FormStepWrapper from 'components/form/FormStepWrapper';
import TextArea from 'components/inputs/TextArea';
import LocationField from 'components/location/picker/LocationField';
import { LocationPickerStep } from 'components/location/picker/LocationPickerStep';
import { Text1 } from 'components/typography/Texts';
import { useAddCampaign } from 'features/add-campaign/context/AddCampaignProvider';
import { useCurrentUser } from 'providers/cache/cachedDataHooks';
import { fromUserLocation } from 'services/utils/location/locationPicker.utils';

const LocationDescription = styled(Text1)`
  margin: 12px 18px;
`;

const SetDescription = () => {
  const { t } = useTranslation('addCampaign');
  const { formData, setFieldValue, errors, isEditMode } = useAddCampaign();
  const { currentUser } = useCurrentUser();
  const [isPickingLocation, setIsPickingLocation] = useState(false);
  const isValid = !errors.description && !errors.campaignLocation;

  useEffect(() => {
    if (isEditMode || formData.campaignLocation) return;
    const profileLocation = fromUserLocation(currentUser?.location);
    if (profileLocation) setFieldValue('campaignLocation', profileLocation);
  }, [isEditMode, formData.campaignLocation, currentUser?.location, setFieldValue]);

  if (isPickingLocation) {
    return (
      <LocationPickerStep
        defaultLocation={formData.campaignLocation}
        onCancel={() => setIsPickingLocation(false)}
        onConfirm={location => {
          setFieldValue('campaignLocation', location);
          setIsPickingLocation(false);
        }}
      />
    );
  }

  return (
    <FormStepWrapper header={t('description.header')} description={t('description.description')} isValid={isValid}>
      <TextArea
        value={formData.description || ''}
        placeholder={t('description.description-input-placeholder')}
        onChange={value => setFieldValue('description', value)}
        errorMessage={errors.description}
      />
      <LocationDescription>{t('description.location-description')}</LocationDescription>
      <LocationField
        mode='step'
        value={formData.campaignLocation}
        onChange={value => setFieldValue('campaignLocation', value)}
        onOpenStep={() => setIsPickingLocation(true)}
        placeholder={t('common:set-location')}
      />
    </FormStepWrapper>
  );
};

export default SetDescription;
